import {IRoutableModule} from '../../router/routing.infra';
import {WifiAnalyzerView} from './view';
import {wifiAnalyzerHistoryRouteLoader} from './wifi-analyzer-history.loader';

export default {
    loader: wifiAnalyzerHistoryRouteLoader,
    Component: WifiAnalyzerView,
    storeAs: 'wifiAnalyzerHistoryStore'
} as IRoutableModule;
